import { render, staticRenderFns } from "./OrganizationalPosition.vue?vue&type=template&id=4dce0a80&scoped=true"
import script from "./OrganizationalPosition.vue?vue&type=script&lang=js"
export * from "./OrganizationalPosition.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalPosition.vue?vue&type=style&index=0&id=4dce0a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce0a80",
  null
  
)

export default component.exports